export default __webpack_public_path__ + "static/Natural_Light_Indoor_320kbps-7a304d92732bab1e499705a7e3e6d9be.avif";